var React = require('react');
var Marionette = require('backbone.marionette');
var ReactComponentView = require('app/common/components/mixins/ReactComponentView');
var DetailMap = require('app/common/components/DetailMap').default;

const DetailMapView = Marionette.ItemView.extend(ReactComponentView).extend({
    template: false,
    getReactComponent() {
        return React.createElement(DetailMap, {
            detailBlock: this.getOption('detailBlock'),
            location: this.getOption('location'),
            neighborhoodGeometry: this.getOption('neighborhoodGeometry'),
            mapboxAccessToken: this.getOption('mapboxAccessToken'),
            zoom: this.getOption('zoom'),
            showCircle: this.getOption('showCircle'),
            showMarker: this.getOption('showMarker'),
            enableNeighborhoodGeometry: this.getOption('enableNeighborhoodGeometry'),
        });
    },
});

module.exports = DetailMapView;
